// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"75":"675d3b1c","157":"1915d729","456":"3c29d4eb","948":"a147d068","959":"1af4c270"}[chunkId] + ".chunk.js";
};